export const REPEAT_TYPES = {
  EVERYDAY: "everyday",
  WEEKDAYS: "weekdays",
  WEEKEND: "weekend",
  CUSTOM: "custom"
}

export const WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

export const MINUTES_PER_DAY = 24 * 60
